// Import model
import { DataviewPaymentTermsResponse } from '../models/DataviewPaymentTermsResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterPaymentTermsRequest } from '../models/FilterPaymentTermsRequest';
import { PaymentTerms } from '../models/PaymentTerms';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterPaymentTermsRequestSerializer } from './FilterPaymentTermsRequestSerializer';
import { PaymentTermsSerializer } from './PaymentTermsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewPaymentTermsResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewPaymentTermsResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewPaymentTermsResponse instance
   */
  static deserialize(json: string): DataviewPaymentTermsResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewPaymentTermsResponse instance
   */
  static fromObject(obj: any): DataviewPaymentTermsResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewPaymentTermsResponse');
    }


    const instance: DataviewPaymentTermsResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        PaymentTermsSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterPaymentTermsRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewPaymentTermsResponse instances
   */
  static deserializeArray(json: string): DataviewPaymentTermsResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewPaymentTermsResponse instance to a JSON string
   */
  static serialize(instance: DataviewPaymentTermsResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewPaymentTermsResponse instance to a plain object
   */
  static toObject(instance: DataviewPaymentTermsResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        PaymentTermsSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterPaymentTermsRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewPaymentTermsResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewPaymentTermsResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
